import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

export const FourModuleLeftMenu = (props) => {

    useEffect(()=>{
        window.addEventListener('scroll',()=>{
            const scrllDistance = window.scrollY;
            const menu = document.querySelector('.four-menu');
            if(!menu){
                return;
            }
            if(scrllDistance > 150){
                menu.style.position = "fixed";
                menu.style.top = "30px"
            }else{
                menu.removeAttribute('style');
            }
        })
    })

    return(
        <ul className="four-menu">
            {props.menus.map((item,index)=>(<li key={index}><NavLink activeClassName="active-left-menu" to={item.path} exact>{item.title}</NavLink></li>))}
        </ul>
    )
}

export default FourModuleLeftMenu;